var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/language"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C12 21 16 17.7273 16 12C16 6.27273 12 3 12 3C12 3 8 6.27273 8 12C8 17.7273 12 21 12 21Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M2.5 9H21.5",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M2.5 15H21.5",
    stroke: "black",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.60801cd1288105e302003d5e93c256a4.svg";
export { ForwardRef as ReactComponent };